import { FloatingPanelProvider } from './FloatingPanelContext';
import { FloatingPanelImplementation, type FloatingPanelProps as PanelProps } from './FloatingPanelImplementation';

export interface FloatingPanelProps extends PanelProps {
  title: string;
  defaultMinimized?: boolean;
}

export function FloatingPanel({
  title,
  defaultMinimized,
  ...panelProps
}: FloatingPanelProps) {
  return (
    <FloatingPanelProvider
      title={title}
      defaultMinimized={defaultMinimized}
    >
      <FloatingPanelImplementation {...panelProps} />
    </FloatingPanelProvider>
  );
}